__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-travel-search-rooms-travelers'].baseUrl;
import ModuleContainer from './components/TravelSearchRoomsTravelers';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    requiredExternals: {
      '@americanexpress/conditional-features': '^3.0.0',
      '@americanexpress/one-app-module-wrapper': '^3.4.2',
      'react-intl': '^6.3.2'
    }
  });
}